import { render } from "./HelloGraphQL.vue?vue&type=template&id=4eae75ba"
import script from "./HelloGraphQL.vue?vue&type=script&lang=js"
export * from "./HelloGraphQL.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__